// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"f97993efc99e6afe591f","655":"4cd34fddaedcf5193bde"}[chunkId] + ".js";
};